import { Directive, HostBinding, Input } from '@angular/core';
import {
  MultiRoutePickerError,
  RoutePickerError
} from '@com-delta-omnichannel/mach';

@Directive({
  standalone: true,
  selector: '[idpErrorState]'
})
export class ErrorStateDirective {
  @Input() idpErrorState!: boolean | RoutePickerError | MultiRoutePickerError;

  @HostBinding('class.book-widget-field-error') get hasError() {
    if (typeof this.idpErrorState === 'boolean') return this.idpErrorState;
    else {
      //structure of MultiRoutePickerError and RoutePickerError is same
      return (
        this.idpErrorState.destination ||
        this.idpErrorState.origin ||
        this.idpErrorState.sameRoute
      );
    }
  }
}
